import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/font-awesome/css/font-awesome.min.css'; 
import 'react-datepicker/dist/react-datepicker.css';
import "./index.css"

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://9e295c555d94f0cec662ad899d30c2db@o4508697420300288.ingest.us.sentry.io/4509649492180992",
  sendDefaultPii:true
});

const RootComponent = <App />;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  process.env.NODE_ENV === "development" ? (
    <React.StrictMode>{RootComponent}</React.StrictMode>
  ) : (
    RootComponent
  )
);